<script setup lang = "ts">
import type {ICarFilter} from "~/interfaces/ICarFilter";

defineProps({
	isLoading: Boolean,
})
const carFilters = defineModel<ICarFilter>({required: true})
const emits = defineEmits(['removeFilterValue'])
const {formatCurrency, formatNumberShort} = useNumberFormat()

const getFilterValueMinMax = (filter: any) => {
	let values = filter.value
	let info = '';
	switch (filter.attribute) {
		case 'price':
			values = {
				min: values.min == 0 ? 'El más bajo' : formatCurrency(values.min),
				max: values.max == 999999999 ? 'El más alto' : formatCurrency(values.max)
			}
			info = 'Precio';
			break;
		case 'cars.millage':
			info = 'Millage';
			values = {
				min: formatNumberShort(values.min),
				max: formatNumberShort(values.max)
			}
			break;
		case 'cars.year':
			info = 'Año';
			values = {
				min: values.min,
				max: values.max
			}
			break;
		default:
			info = filter.attribute
			values = {
				min: formatNumberShort(values.min),
				max: formatNumberShort(values.max)
			}
	}
	
	return `${info}: ${filter.value.min ? 'min: ' + values.min : ''}${filter.value.min && filter.value.max ? ' - ' : ' '}${filter.value.max ? 'max: ' + values.max : ''}`
}
const getFilterAttributeValue = (attribute: any) => {
	switch (attribute) {
		case 'cars.color':
			return 'Exterior'
		case 'cars.interior_color':
			return 'Interior'
		case 'cars.transmission':
			return 'Transmisión'
		case 'cars.drive_train':
			return 'Tren de manejo'
		case 'cars.body_style':
			return 'Tipo'
		case 'cars.fuel_type':
			return 'Combustible'
		default:
			return attribute
	}
}

</script>

<template>
	<div class = "flex border border-l-0 border-r-0 border-gray-300 sticky top-0">
		<template v-for = "filter in Object.values(carFilters)">
			<q-chip color = "primary" class = "text-white" size = "12px"
							v-if = "filter.type=='complete-text-search' && !!filter.value"
							:removable = "!isLoading"
							@remove = "$emit('removeFilterValue',filter.attribute)">
				{{ $t(filter.value) }}
			</q-chip>
			<q-chip color = "primary" class = "text-white" size = "12px"
							v-if = "filter.type=='minmax' && !!(filter.value.min || filter.value.max)"
							:removable = "!isLoading"
							@remove = "$emit('removeFilterValue',filter.attribute)">
				{{ getFilterValueMinMax(filter) }}
			</q-chip>
			<q-chip v-if = "filter.type=='in-match' && !filter.value?.includes('%')" v-for = "value in filter.value"
							color = "primary" class = "text-white" size = "12px"
							:removable = "!isLoading"
							@remove = "$emit('removeFilterValue',filter.attribute)">
				{{ getFilterAttributeValue(filter.attribute) }}:
				<div class = "pl-1" v-if = "filter.attribute=='cars.body_style'">
					{{ value.body_style }}
				</div>
				<div class = "pl-1" v-else>
					{{ filter.attribute.toString().includes('color') ? $t(value) : value }}
				</div>
			</q-chip>
		</template>
	</div>
</template>

<style scoped>

</style>